import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { styleVariables } from '@lib/common';
import { SubmissionOverviewStatus } from '@module/assignment';
import styled, { getSize } from '@xstyled/styled-components';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var getColorBySubmissionOverviewStatus = function getColorBySubmissionOverviewStatus(statusType) {
  switch (statusType) {
    case SubmissionOverviewStatus.unFinished.value:
      return "color: ".concat(styleVariables.colors.gray10, "; background: ").concat(styleVariables.colors.gray3, "; border: 1px solid ").concat(styleVariables.colors.gray10, ";");

    case SubmissionOverviewStatus.finished.value:
      return "color: ".concat(styleVariables.colors.colorSuccessBase, "; background: ").concat(styleVariables.colors.colorSuccessBg, "; border: 1px solid ").concat(styleVariables.colors.colorSuccessBase, ";");

    case SubmissionOverviewStatus.banned.value:
      return "color: ".concat(styleVariables.colors.red3, "; background: ").concat(styleVariables.colors.red1, "; border: 1px solid ").concat(styleVariables.colors.red3, ";");

    default:
      return "color: ".concat(styleVariables.colors.gray10, "; background: ").concat(styleVariables.colors.gray3, "; border: 1px solid ").concat(styleVariables.colors.gray10, ";");
  }
};
var StyledSubmissionOverviewStatusComponent = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1px 8px;\n  ", ";\n  width: fit-content;\n  border-radius: ", ";\n  display: block;\n  text-align: center;\n  font-size: ", ";\n"])), function (_ref) {
  var statusType = _ref.statusType;
  return getColorBySubmissionOverviewStatus(statusType);
}, getSize('radiusSm'), getSize('typo12'));
export var getTranslatedSubmissionOverviewStatusName = function getTranslatedSubmissionOverviewStatusName(statusId, translation) {
  switch (statusId) {
    case SubmissionOverviewStatus.unFinished.value:
      return translation.statusNotCompleted;

    case SubmissionOverviewStatus.finished.value:
      return translation.statusDone;

    case SubmissionOverviewStatus.banned.value:
      return translation.statusBanned;

    default:
      return '';
  }
};
export var SubmissionOverviewStatusComponent = function SubmissionOverviewStatusComponent(_ref2) {
  var statusType = _ref2.statusType,
      text = _ref2.text,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100px' : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? '22px' : _ref2$height,
      style = _ref2.style,
      className = _ref2.className;
  return /*#__PURE__*/_jsx(StyledSubmissionOverviewStatusComponent, {
    statusType: statusType,
    width: width,
    height: height,
    style: style,
    className: className,
    children: text
  });
};